import { LogoPropsType } from './logoTypes';

export default function SapLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16" className={className}>
      <g clipPath="url(#spa-path)">
        <path
          fill={monochrome ? 'currentColor' : '#fff'}
          fillRule="evenodd"
          d="m19.584 3.008-3.248-.002v7.57l-2.838-7.57h-2.814l-2.423 6.33C8.003 7.74 6.32 7.19 4.993 6.776 4.118 6.5 3.19 6.095 3.198 5.647c.007-.367.498-.709 1.47-.657.654.034 1.23.085 2.378.627l1.129-1.926c-1.048-.522-2.495-.852-3.68-.853h-.007c-1.383 0-2.535.439-3.25 1.163a2.658 2.658 0 0 0-.776 1.857c-.019.977.347 1.67 1.115 2.222.648.467 1.478.768 2.209.99.902.274 1.638.512 1.63 1.02a.742.742 0 0 1-.215.497c-.224.228-.57.313-1.047.322-.92.019-1.602-.123-2.69-.752L.463 12.11a7.62 7.62 0 0 0 3.677.959l.168-.002c1.14-.02 2.06-.338 2.795-.919.043-.032.08-.066.12-.1l-.326.853h2.95l.496-1.476c.518.173 1.108.27 1.734.27.61 0 1.184-.092 1.693-.256l.478 1.462h4.812V9.845h1.05c2.537 0 4.037-1.267 4.037-3.389 0-2.364-1.458-3.448-4.562-3.448Zm-7.508 6.477c-.379 0-.734-.065-1.04-.178l1.03-3.184h.019l1.011 3.193c-.304.105-.65.169-1.02.169Zm7.699-1.83h-.716V5.09h.716c.954 0 1.715.31 1.715 1.266 0 .988-.76 1.3-1.715 1.3Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="spa-path">
          <path fill={monochrome ? 'currentColor' : '#fff'} d="M0 0h24v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
